import { render, staticRenderFns } from "./AirportPage.vue?vue&type=template&id=0f667073&"
import script from "./AirportPage.vue?vue&type=script&lang=js&"
export * from "./AirportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports